export const DAILY_COUNT = 'daily-count';
export const FLIGHT_CURVE = 'flight-curve';
export const NETWORK_MANAGEMENT = 'network-management';

/** Width of the collapsed app nav rail the trap-details drawer sits beside. */
export const APP_NAV_RAIL_WIDTH = 64;

/** Width of the desktop trap-details drawer. */
export const TRAP_DETAILS_DRAWER_WIDTH = 640;

/**
 * How far the drawer reaches across the full-viewport map canvas. Half of it is
 * the camera offset that keeps a selected trap centred in the strip still visible.
 */
export const TRAP_DETAILS_DRAWER_RIGHT_EDGE = APP_NAV_RAIL_WIDTH + TRAP_DETAILS_DRAWER_WIDTH;
